import { Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { Toaster } from 'sonner';
import '@rainbow-me/rainbowkit/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'aos/dist/aos.css';

import { config } from './wagmi';
import './i18n';
import './styles/main.css';

import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Overview from './pages/dashboard/Overview';
import Deposits from './pages/dashboard/Deposits';
import NewDeposit from './pages/dashboard/NewDeposit';
import Referrals from './pages/dashboard/Referrals';
import Activity from './pages/dashboard/Activity';
import { ReferralCodeProvider } from './contexts/ReferralCodeContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

const customTheme = darkTheme({
  accentColor: '#FFCB47',
  accentColorForeground: '#0A0A0B',
  borderRadius: 'medium',
  fontStack: 'system',
  overlayBlur: 'small',
});

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={customTheme}>
          <ReferralCodeProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/dashboard" element={<Dashboard />}>
                <Route index element={<Navigate to="overview" replace />} />
                <Route path="overview" element={<Overview />} />
                <Route path="deposits" element={<Deposits />} />
                <Route path="new" element={<NewDeposit />} />
                <Route path="referrals" element={<Referrals />} />
                <Route path="activity" element={<Activity />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" theme="dark" richColors closeButton />
          </ReferralCodeProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
